import { mapState } from "vuex";
export const realTimeInfoIndexMixins = {
  computed: {
    realTimeInfoTopBarList() {
      let topbarList = [
        {
          name: "资讯管理",
          isActive: false,
          path: "/realTimeInfo",
          icon:require("@/assets/img/menuIcons/icon-realTimeInfo.png")
        },
        {
          name: "分类管理",
          isActive: false,
          path: "/realTimeInfoClass",
          icon:require("@/assets/img/menuIcons/icon-realTimeInfoClass.png")
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
}
